import React from 'react';
import { Row, Col, Input, Spinner } from 'reactstrap';

// Placeholders
import placeholder from "assets/images/info/card-placeholder.png";
import placeholderMedium from "assets/images/info/card-placeholder-medium.png";
import placeholderSmall from "assets/images/info/card-placeholder-small.png";

const ThumbnailUploader = ({
  original,
  medium,
  small,
  handleFileChange
}) => {
  return (
    <Row className="mb-1 mb-md-3">
      {/* -------- 1536x1024px -------- */}
      <Col xs={12} md={4} className="d-flex flex-column mb-3 mb-md-0">
        <Row>
          <Col xs={12} md={12} className="d-flex flex-column justify-content-start pt-4 pt-md-0">
            <Row className="mb-2">
              <Col xs={6} md={8}><p className="mb-1">1536x1024px</p></Col>
              <Col xs={6} md={4} className="d-flex justify-content-start justify-content-md-end">
                {original.isSaving && <span style={{ color: "#f1b34c" }}>Saving...</span>}
                {!original.isSaving && !original.isError && (
                  <span style={{ color: original.isSaved ? "#34c38f" : "#aeabab" }}>✔ Saved</span>
                )}
                {!original.isSaving && original.isError && (
                  <span style={{ color: "red" }}>Error Saving Thumbnail!</span>
                )}
              </Col>
            </Row>
            <Row className="mb-2">
              <Col xs={12}>
                <Input type="file" accept="image/*"
                  onChange={(e) => handleFileChange(e, original.uploadThumbnail, "sizeOriginal")}
                />
              </Col>
            </Row>
          </Col>
          <Col xs={8} md={12}>
            <div style={{ maxWidth: "100%", minHeight: "16vw", border: small.isLoading ? '0.5px solid #c1c6cf' : 'none', backgroundColor: "#f9f9f9", borderRadius: '10px' }}
              className="d-flex justify-content-center align-items-center">
              {small.isLoading && !small.isLoading ? (
                <Spinner style={{ color: "#a1d2e7", height: "32px", width: "32px", margin: "0" }} />
              ) : (
                <img
                  src={original.url || medium.url || small.url || placeholder}
                  alt="Collection Thumbnail"
                  style={{ width: "100%", height: "auto", borderRadius: '8px' }}
                />
              )}
            </div>
            <Row style={{ width: "100%", minHeight: "27px" }}>
              <Col xs={8} lg={8} className="d-flex justify-content-center">
                <div style={{ fontSize: "0.9rem", color: "#666", marginTop: "0.3rem" }}>
                  {original?.imageInfo?.width || 0} × {original?.imageInfo?.height || 0}px
                </div>
              </Col>
              <Col xs={4} lg={4} className="d-flex justify-content-center">
                <div style={{ fontSize: "0.9rem", color: "#666", marginTop: "0.3rem" }}>
                  {original?.imageInfo?.sizeKB || 0} KB
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Col>

      {/* -------- 576x384px -------- */}
      <Col xs={12} md={4} className="d-flex flex-column mb-3 mb-md-0">
        <Row>
          <Col xs={12} md={12} className="d-flex flex-column justify-content-start pt-4 pt-md-0">
            <Row className="mb-2">
              <Col xs={6} md={8}><p className="mb-1">576x384px</p></Col>
              <Col xs={6} md={4} className="d-flex justify-content-start justify-content-md-end">
                {medium.isSaving && <span style={{ color: "#f1b34c" }}>Saving...</span>}
                {!medium.isSaving && !medium.isError && (
                  <span style={{ color: medium.isSaved ? "#34c38f" : "#aeabab" }}>✔ Saved</span>
                )}
                {!medium.isSaving && medium.isError && (
                  <span style={{ color: "red" }}>Error Saving Medium Thumbnail!</span>
                )}
              </Col>
            </Row>
            <Row className="mb-2">
              <Col xs={12}>
                <Input type="file" accept="image/*"
                  onChange={(e) => handleFileChange(e, medium.uploadThumbnail, "sizeMedium")}
                />
              </Col>
            </Row>
          </Col>
          <Col xs={8} md={12}>
            <div style={{ maxWidth: "100%", minHeight: "16vw", border: small.isLoading ? '0.5px solid #c1c6cf' : 'none', backgroundColor: "#f9f9f9", borderRadius: '10px' }}
              className="d-flex justify-content-center align-items-center">
              {small.isLoading && !small.isLoading ? (
                <Spinner style={{ color: "#a1d2e7", height: "32px", width: "32px", margin: "0" }} />
              ) : (
                <img
                  src={medium.url || small.url || placeholderMedium}
                  alt="Collection Thumbnail"
                  style={{ width: "100%", height: "auto", borderRadius: '8px' }}
                />
              )}
            </div>
            <Row style={{ width: "100%", minHeight: "27px" }}>
              <Col xs={8} lg={8} className="d-flex justify-content-center">
                <div style={{ fontSize: "0.9rem", color: "#666", marginTop: "0.3rem" }}>
                  {medium?.imageInfo?.width || 0} × {medium?.imageInfo?.height || 0}px
                </div>
              </Col>
              <Col xs={4} lg={4} className="d-flex justify-content-center">
                <div style={{ fontSize: "0.9rem", color: "#666", marginTop: "0.3rem" }}>
                  {medium?.imageInfo?.sizeKB || 0} KB
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Col>

      {/* -------- 216x144px -------- */}
      <Col xs={12} md={4} className="d-flex flex-column mb-3 mb-md-0">
        <Row>
          <Col xs={12} md={12} className="d-flex flex-column justify-content-start pt-4 pt-md-0">
            <Row className="mb-2">
              <Col xs={6} md={8}><p className="mb-1">216x144px</p></Col>
              <Col xs={6} md={4} className="d-flex justify-content-start justify-content-md-end">
                {small.isSaving && <span style={{ color: "#f1b34c" }}>Saving...</span>}
                {!small.isSaving && !small.isError && (
                  <span style={{ color: small.isSaved ? "#34c38f" : "#aeabab" }}>✔ Saved</span>
                )}
                {!small.isSaving && small.isError && (
                  <span style={{ color: "red" }}>Error Saving Small Thumbnail!</span>
                )}
              </Col>
            </Row>
            <Row className="mb-2">
              <Col xs={12}>
                <Input type="file" accept="image/*"
                  onChange={(e) => handleFileChange(e, small.uploadThumbnail, "sizeSmall")}
                />
              </Col>
            </Row>
          </Col>
          <Col xs={8} md={12}>
            <div style={{ width: "100%", minHeight: "19vw", display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column" }}>
              <div style={{
                maxWidth: "100%",
                minHeight: "10vw",
                minWidth: "16vw",
                backgroundColor: "#f9f9f9",
                border: small.isLoading ? "0.5px solid #c1c6cf" : "none",
                borderRadius: "10px"
              }} className="d-flex justify-content-center align-items-center">
                {small.isLoading && !small.isLoading ? (
                  <Spinner style={{ color: "#a1d2e7", height: "32px", width: "32px", margin: "0" }} />
                ) : (
                  <img
                    src={small.url || placeholderSmall}
                    alt="Collection Thumbnail"
                    style={{ width: "100%", height: "auto", borderRadius: "8px" }}
                  />
                )}
              </div>
              <Row style={{ width: "100%", minHeight: "27px" }}>
                <Col xs={6} lg={6} className="d-flex justify-content-center justify-content-lg-end">
                  <div style={{ fontSize: "0.9rem", color: "#666", marginTop: "0.3rem" }}>
                    {small?.imageInfo?.width || 0} × {small?.imageInfo?.height || 0}px
                  </div>
                </Col>
                <Col xs={6} lg={6} className="d-flex justify-content-center justify-content-lg-start">
                  <div style={{ fontSize: "0.9rem", color: "#666", marginTop: "0.3rem" }}>
                    {small?.imageInfo?.sizeKB || 0} KB
                  </div>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default ThumbnailUploader;
